<script>
	const stringUtilities = require('utilities/stringUtilities');
	module.exports = {
		props: {
			studentName: {
				type: String,
				default: ''
			},
			value: {
				type: String
			},
			editable: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				note: ''
			};
		},
		computed: {
			name() {
				return stringUtilities.stripHTML(this.studentName);
			}
		},
		watch: {
			value: {
				handler(value) {
					this.note = value;
				},
				immediate: true
			}
		},
		components: {
			'validated-textarea': require('components/validated-textarea.vue').default,
			'comment-icon': require('components/svg/comment-icon.vue').default
		},
		methods: {
			togglePopup() {
				if (this.$refs.popup.isOpen) {
					this.$refs.popup.hide();
				} else {
					this.$refs.popup.show(this.$refs.noteButton, 'Note');
				}
			},
			save(event) {
				this.note = event.target.value;
				this.$emit('change-note', event.target.value);
			},
			clearNote(event) {
				this.note = '';
				this.$emit('change-note', '');
			}
		}
	};
</script>
<template>
	<div
		class="bok-note"
		:class="{ 'bok-note-populated': !!note }">
		<button
			class="button -link note-button"
			ref="noteButton"
			aria-label="Add note"
			aria-haspopup="dialog"
			@click="togglePopup">
			<comment-icon width="28px"></comment-icon>
		</button>
		<popup
			ref="popup"
			class="note">
			<div slot="content">
				<template v-if="editable">
					<button
						v-if="note"
						@click="clearNote"
						aria-label="Clear note"
						class="button -link clear-note">
						<i class="fa-regular fa-trash-can"></i>
					</button>
					<validated-textarea
						@change.native.stop="save"
						:value="note"
						:rows="4"
						:placeholder="name ? 'Add a note to ' + name + '...' : 'Add a note...'"
						:hide-message-bar="true"></validated-textarea>
				</template>
				<div v-else>
					{{ note }}
				</div>
			</div>
		</popup>
	</div>
</template>
<style lang="scss">
	@import 'config/colors';

	.bok-note {
		font-size: 0.75rem;
		display: inline;

		.popup {
			z-index: 1;
		}

		.comment-icon {
			cursor: pointer;
		}

		&.bok-note-populated .comment-icon {
			fill: $c-blue;
		}

		.clear-note {
			position: absolute;
			top: 0.2rem;
			right: 1.6rem;
			font-size: 1.2rem;
			color: $c-disabled-grey;
			cursor: pointer;
			padding: 0;
		}

		.validated-textarea {
			width: 16.5rem;
		}
	}
</style>
